export default __webpack_public_path__ + "static/media/tableau_de_bord.c445c51b.svg";